import React, { useEffect, useState, useCallback } from 'react';
import { Query, useMutation, useApolloClient } from 'react-apollo';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import Checkbox from '@material-ui/core/Checkbox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Button from 'components/common/Button';
import TextInput from 'components/form/Input';
import { GET_MODULES } from 'graphql/admin/curriculum';
import Loading from 'components/common/Spin';

const CurriculumCopyModal = ({ curriculum_id, onClose, onSave }) => {
  const client = useApolloClient();
  const [modules, setModules] = useState();
  const [name, setName] = useState('');
  useEffect(() => {
    client
      .query({
        query: GET_MODULES,
        variables: {
          curriculum_id,
        },
      })
      .then(({ data }) => setModules(data.modules));
  }, []);

  const [selectedModules, setSelectedModules] = useState([]);
  const [expanded, setExpanded] = useState({});

  const handleSubmit = () => {
    const data = selectedModules.map(
      ({ id, curriculum_id, __typename, ...module }) => {
        return {
          ...module,
          exercises: {
            data: module.exercises
              .filter((e) => e.checked)
              .map(({ id, module_id, checked, __typename, ...exercise }) => exercise),
          },
        };
      },
    );
    return onSave(name, data);
  };

  const toggleExpand = (item) => () => {
    expanded[item.id] = !expanded[item.id];
    setExpanded({ ...expanded });
  };

  const toggleModuleCheck = (item) => (e) => {
    const { checked } = e.target;
    item.exercises.forEach((ex) => {
      ex.checked = checked;
    });
    if (checked) {
      setSelectedModules([...selectedModules, item]);
    } else {
      setSelectedModules(selectedModules.filter((i) => i !== item));
    }
  };

  const toggleExCheck = (mod, ex) => (e) => {
    const { checked } = e.target;
    const moduleCheck = selectedModules.find((i) => i === mod);
    ex.checked = checked;
    if (checked && !moduleCheck) {
      setSelectedModules([...selectedModules, mod]);
    } else {
      setSelectedModules([...selectedModules]);
    }
  };

  const isInterminate = (mod) => {
    if (selectedModules.find((i) => i.id === mod.id)) {
      const total = mod.exercises.length;
      const checked = mod.exercises.filter((i) => i.checked).length;
      return total !== checked;
    }
    return false;
  };

  const exChecked = (ex) => {
    const mod = selectedModules.find((i) => i.id === ex.module_id);
    if (!mod) return false;
    return mod.exercises.find((x) => x.id === ex.id && x.checked);
  };

  return (
    <Dialog open fullWidth maxWidth="xs" scroll="body">
      <DialogTitle>Copy Curriculum</DialogTitle>
      <DialogContent>
        {!modules ? (
          <Loading spinning />
        ) : (
          <>
            <TextInput
              label="Curriculum name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <List>
              {modules.map((mod) => (
                <>
                  <ListItem button key={mod.id} onClick={toggleExpand(mod)}>
                    <ListItemIcon>
                      {expanded[mod.id] ? <ExpandLess /> : <ExpandMore />}
                    </ListItemIcon>
                    <ListItemText primary={mod.name} />
                    <ListItemSecondaryAction>
                      <Checkbox
                        color="primary"
                        indeterminate={isInterminate(mod)}
                        checked={selectedModules.includes(mod)}
                        onChange={toggleModuleCheck(mod)}
                      />
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Collapse in={expanded[mod.id]} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding dense>
                      {mod.exercises.map((ex) => (
                        <ListItem
                          button
                          style={{ paddingLeft: 32 }}
                          key={ex.id}
                        >
                          <ListItemText
                            primary={ex.name}
                            primaryTypographyProps={{ variant: 'caption' }}
                          />
                          <ListItemSecondaryAction>
                            <Checkbox
                              size="small"
                              color="primary"
                              checked={exChecked(ex)}
                              onChange={toggleExCheck(mod, ex)}
                            />
                          </ListItemSecondaryAction>
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>
                </>
              ))}
            </List>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button disabled={!name || !selectedModules.length} variant="contained" color="primary" onClick={handleSubmit}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CurriculumCopyModal;
